import { render, staticRenderFns } from "./NovaSenha.vue?vue&type=template&id=26488a04"
import script from "./NovaSenha.vue?vue&type=script&lang=js"
export * from "./NovaSenha.vue?vue&type=script&lang=js"
import style0 from "./NovaSenha.vue?vue&type=style&index=0&id=26488a04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports